import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { GroceryPendingCartInput } from '@/models/grocery';

export const createGroceryPendingCart = async ({
  phoneNumber,
  email,
  storeName,
  link,
  notes,
}: GroceryPendingCartInput): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateGroceryPendingCart($phoneNumber: String!, $email: String!, $storeName: String!, $link: String!, $notes: String!) {
        createGroceryPendingCart(phoneNumber: $phoneNumber, email: $email, storeName: $storeName, link: $link, notes: $notes) {
          id
        }
      }
    `),
    variables: {
      phoneNumber,
      email,
      storeName,
      link,
      notes,
    },
  });

  return !!response.data?.createGroceryPendingCart;
};
